import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './components/AboutHeroSection';
import AboutUsSection from './components/AboutUsSection';
import PhilosophySection from './components/PhilosophySection';
import IncrediblyProudSection from './components/IncrediblyProudSection';
import Spotlight from '../../components/organisms/Spotlight';
import InstagramFeed from '../../components/atoms/InstagramFeed';
const AboutPage = () => {
  return (
    <div>
      <Helmet>
        <title>About Us | Guidepost Pediatric Therapies Wasilla Alaska</title>
        <meta
          name="description"
          content="Learn about Guidepost Pediatric Therapies and Educational Services in Wasilla, Alaska. Our team of highly qualified professionals specializes in pediatric occupational, physical, and speech therapy."
        />
        <meta
          name="keywords"
          content="pediatric therapy Wasilla, about Guidepost Pediatrics, pediatric therapy team Alaska, therapy services Wasilla"
        />
      </Helmet>
      <HeroSection />
      <AboutUsSection />
      <PhilosophySection />
      <IncrediblyProudSection />
      <InstagramFeed />
      <Spotlight />
    </div>
  );
};

export default AboutPage;
